module.exports = __webpack_public_path__ + "img/ic_calendar.f91721a8.svg";